<div *ngIf="pop" class="pop">
    <nirby-pop-player
        [campaign]="pop"
        [context]="context"
        (activeUpdate)="isPlayerActive = $event"
    ></nirby-pop-player>
</div>
